import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/pro-regular-svg-icons";
import { faKey} from "@fortawesome/pro-regular-svg-icons";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import CircularProgress from '@mui/material/CircularProgress';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



import DialogX from './Dialog';

import Snackbar from '@mui/material/Snackbar';

import {getConfigValue} from './Config';


const useStyles = makeStyles(theme => ({   
    
    outerRow: {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',
        // marginLeft: '.5em',
        // marginTop: '.5em',       
        backgroundColor:'#F3F3F3',
        // padding: '.5em',
        // paddingTop:'1em',
        width:'100%',
        borderRadius: '3px',
        fontSize: '9pt',
       

    },
    contactDetailsColumn: {
        display: 'flex', 
        flexDirection: 'column',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',  
        padding: '.5em',
        
    },
    contactsInfoLine: {
        marginBottom: '1em',
        fontSize: '8pt',
    },
    contactInfoButtonsColumn: {
        display: 'flex', 
        flexDirection: 'column',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',  
        padding: '.5em',               
    },
    contactsInfoButtons: {
        marginBottom: '1em',
        
    },
   
    usersList: {
        overflow: 'auto',
        maxHeight: 200,
        width: '400px',
      },
      adminRolesList: {
        overflow: 'auto',
        maxHeight: 200,
        width: '250px',
      },
    contactsHeading: {
        fontSize: '12pt',
        marginLeft: '1.3em',
    },
    textField : {
        width: '120px',         
        fontSize: '8pt'
        
      }, 

    }));

    


const UserManagement = (props) => {
    const classes = useStyles();
    var store = require('store')
        
       
    const [admins, setAdmins] = useState([]);
    const [newAdmin, setNewAdmin] = useState({});
    
    const [selectedAdminIndex, setSelectedAdminIndex] = useState(0);
    const [selectedAdminRoleIndex, setSelectedAdminRoleIndex] = useState(0);
    const [selectedAdmin, setSelectedAdmin] = useState({});
    const [allAdminRoles, setAllAdminRoles] = useState([]);
    const [selectedAvailableRoleIndex, setSelectedAvailableRoleIndex] = useState();

    const [dialogOpen, setDialogOpen] = useState();
    const [dialogText, setDialogText] = useState('');

    const [loadingButtons, setLoadingButtons] = useState({});

    const [isFetching, setIsFetching] = useState(false);

    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarText, setSnackbarText] = useState('');
    
 
    const isLoading = (buttonName) => {
        return loadingButtons[buttonName];
    }

    const setLoading =(buttonName, isLoading) => {
        var ldnButtons = {...loadingButtons};
        ldnButtons[buttonName] = isLoading;
        setLoadingButtons(ldnButtons);        
    }

    const handleListItemClick = (index) => {
        setSelectedAdminIndex(index);
        setSelectedAdmin(admins[index]);     
   
    }

 
    const createNewAdmin =() => {
        var newAdmin = {};
        newAdmin.name = "ny admin";
        newAdmin.isNew =true;
       
        setNewAdmin(newAdmin);

        setAdmins([newAdmin, ...admins]);
        setSelectedAdminIndex(0);
        setSelectedAdmin(newAdmin);
        
    }

    const getAdmins = async () => {    
        setAdmins([]);
        setIsFetching(true);

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/getAdmins/${store.get("sessionToken")}`);            
        const json = await res.json();   
               
                 
        if (json["result"]=='success') {                        
            setAdmins(json["admins"]);
            setAllAdminRoles(json["availableRoles"]);
    
            if (selectedAdminIndex>json['admins'].count-1) {
                setSelectedAdminIndex(0);
                setSelectedAdmin(json["admins"][0]);
            }
            else
                setSelectedAdmin(json["admins"][selectedAdminIndex]);

        }

        setIsFetching(false);
        
    }

    const addAdminRole = () =>{ 

        var selectedAvailableAdminRole = getAvailableRoles(allAdminRoles)[selectedAvailableRoleIndex];
        
        console.log("selected ", selectedAvailableAdminRole);

        if (!selectedAdmin.adminRoles.includes(selectedAvailableAdminRole)) {

            selectedAdmin.adminRoles.push(selectedAvailableAdminRole);

            setSelectedAdmin({...selectedAdmin});

            
        }
    }

    const deleteAdminRole = () =>{       
        
        var selectedAdminRole = selectedAdmin.adminRoles[selectedAdminRoleIndex];
        
        selectedAdmin.adminRoles = selectedAdmin.adminRoles.filter(r => r!=selectedAdminRole);

        setSelectedAdmin({...selectedAdmin});
       
    }
    
    const generateAdminPassword = async ()  =>{       
        
        setLoading('generateAdminPassword', true);

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/generateAndEmailAdminPassword/${store.get("sessionToken")}/${selectedAdmin.userName}`);            
        const json = await res.json();   
               
                 
        if (json["result"]=='success') {         
            console.log("password generated and sent successfully")       
            setSnackbarText('Admin passord generert og sendt på epost');       
            setShowSnackbar(true);            ;
        }
           
        

        setLoading('generateAdminPassword', false);
    }

    //force log out admin
    const kickAdmin = async ()  =>{       
        
        setLoading('kickAdmin', true);

        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/kickAdmin/${store.get("sessionToken")}/${selectedAdmin.userName}`);            
        const json = await res.json();   
               
                 
        if (json["result"]=='success') {         
            console.log("Admin forced log out completed")  
            setSnackbarText('Admininistratoren er ikke lenger innlogget');            
            setShowSnackbar(true);            ;
        }
           
        

        setLoading('kickAdmin', false);
    }

    const upsertAdmin = async () =>{       
                
        setLoading('upsertAdmin', true);

        const response = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/upsertAdmin/${store.get("sessionToken")}`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.          
            headers: {
              'Content-Type': 'application/json'             
            },            
            body: JSON.stringify(selectedAdmin) // body data type must match "Content-Type" header
          });
          
          const json = await response.json(); // parses JSON response into native JavaScript objects


          setLoading('upsertAdmin', false);

          getAdmins(); //refresh list

    }



    const confirmDeleteAdmin = () =>{        
        setDialogText(`Er du sikkert på at du vil slette administratoren ${getSelectedAdminField('name')} ? Personen vil ikke lenger ha tilgang til admin-grensesnittet i fakturahotellet.`)        
        setDialogOpen(true);
    }

    const deleteAdmin = async (dialogResult) => {
        setLoading('deleteAdmin', true);

        if (dialogResult!==true) //dialog confirmed, true/false
            return;                
        
        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/deleteAdmin/${store.get("sessionToken")}/${selectedAdmin.userName}`);            
        const json = await res.json();   

        getAdmins();     
        setSelectedAdminIndex(0);      
        setSelectedAdmin(admins[0]);
        
        setLoading('deleteAdmin', false);
        
    }

    const updateAdminUserField = (field, value) => {
       
        if (selectedAdmin) {
            var updatedAdmin = {...selectedAdmin, [field]:value};        
            setSelectedAdmin(updatedAdmin);
          
        }
            
    }

  

    const getAvailableRoles = () => {
        if (!selectedAdmin || !allAdminRoles || !selectedAdmin.adminRoles)
            return [];
        else
            return allAdminRoles.filter(r => !selectedAdmin.adminRoles.includes(r))
    }

    const getSelectedAdminField = (field) => {
        if (selectedAdmin && selectedAdmin[field])
            return selectedAdmin[field];
        else
            return '';

    }
   
    const isEmailValid = () => {
        if (!selectedAdmin)
            return false;

        return String(selectedAdmin.userName)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };
    
    useEffect(() =>  { //run once on load
        getAdmins();  
        
        
      },[props.doRefresh])

    return(              

        <div style={{marginTop: '.5em'}}>
        {dialogOpen && <DialogX dialogText={dialogText} onCompletionFunc={deleteAdmin} setDialogOpen={setDialogOpen}/> }
        

        <Accordion style={{backgroundColor: '#F3F3F3',marginLeft: '.5em'}} >
         <AccordionSummary style={{backgroundColor: '#F3F3F3'}}
          expandIcon={<ExpandMoreIcon />}                  
        >
          Aministratorbrukere ({admins.length})
        </AccordionSummary>
         
        <AccordionDetails>        
        <div className={classes.outerRow}> 

            <div >                           

                <div>
                { isFetching && <CircularProgress /> }
                <List className={classes.usersList} dense={true}>
                    {admins && admins.map((item,index) => 
                        <ListItem selected={index==selectedAdminIndex} onClick={() => handleListItemClick(index)}>
                            <ListItemIcon>
                                <FontAwesomeIcon icon={faUser} />
                            </ListItemIcon>
                            <ListItemText
                                primary={ item.name}
                                secondary={item.userName}
                            />
                        </ListItem>
                    )}               
                </List>
                </div>  
            
            </div>

            <div className={classes.contactDetailsColumn} >
                <div className={classes.contactsInfoLine}>
                    <TextField InputLabelProps={{shrink: true}} inputProps={{style: {fontSize: 12}}} style={{width: '203px'}}
                     value= {getSelectedAdminField('name')} className={classes.textField} onChange={e => updateAdminUserField('name', e.target.value)} 
                     variant="outlined" label="Navn" size='small'></TextField>
                    {/* &nbsp;
                    <TextField InputLabelProps={{shrink: true}} inputProps={{style: {fontSize: 12}}} value={userName} className={classes.textField} onChange={e => setUserName(e.target.value)} variant="outlined" label="Epost" size='small'></TextField>
                */}
                </div>

                <div className={classes.contactsInfoLine}>
                    <TextField disabled={selectedAdmin && !selectedAdmin.isNew} InputLabelProps={{shrink: true}} inputProps={{style: {fontSize: 12}}} style={{width: '203px'}} value={getSelectedAdminField('userName')} className={classes.textField} onChange={e => updateAdminUserField('userName', e.target.value)} variant="outlined" label="Epost" size='small'></TextField>                   
                </div>

                {selectedAdmin && <div> Roller for {selectedAdmin.name} </div> }
                
                <div className={classes.contactsInfoLine}>
                    <List className={classes.adminRolesList} dense={true}>
                        {selectedAdmin && selectedAdmin.adminRoles && selectedAdmin.adminRoles.map((item,index) => 
                            <ListItem selected={index==selectedAdminRoleIndex} onClick={() => setSelectedAdminRoleIndex(index)}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faKey} />
                                </ListItemIcon>
                                <ListItemText                                    
                                    primary={ item}
                                    //secondary={item}                                    
                                />
                            </ListItem>
                        )}               
                    </List>
                <div className={classes.contactsInfoButtons} >
                    <LoadingButton onClick={deleteAdminRole}
                    style={{minWidth: '70px'}} variant="contained" size='small'
                     color="primary" className={classes.primaryButton}>Slett Rolle</LoadingButton>      
                </div>   
                </div>
            </div>

            <div className={classes.contactDetailsColumn} >
                
            <div style={{height: '90px'}}>
            <LoadingButton disabled={!isEmailValid() || !selectedAdmin || selectedAdmin.isNew} loading={isLoading('generateAdminPassword')} onClick={generateAdminPassword}
                style={{minWidth: '70px'}} variant="contained" size='small'
                color="primary" className={classes.primaryButton}>Opprett og send passord
            </LoadingButton>   
            </div> 

                Tilgjengelige Roller
                <div className={classes.contactsInfoLine}>
                    <List className={classes.adminRolesList} dense={true}>
                        {getAvailableRoles(allAdminRoles).map((item,index) => 
                            <ListItem selected={index==selectedAvailableRoleIndex} onClick={() => setSelectedAvailableRoleIndex(index)}>
                                <ListItemIcon>
                                    <FontAwesomeIcon icon={faKey} />
                                </ListItemIcon>
                                <ListItemText                                    
                                    primary={ item}
                                    //secondary={item}                                    
                                />
                            </ListItem>
                        )}               
                    </List>
                    <div className={classes.contactsInfoButtons} >
                    <LoadingButton onClick={addAdminRole}
                    style={{minWidth: '70px'}} variant="contained" size='small'
                     color="primary" className={classes.primaryButton}> Legg Til </LoadingButton>      
                </div> 
                </div>

            </div>


            <div className={classes.contactInfoButtonsColumn}>
                <div className={classes.contactsInfoButtons} >
                    <LoadingButton disabled={!isEmailValid()} loading={isLoading('upsertAdmin')} onClick={upsertAdmin}
                    style={{minWidth: '70px'}} variant="contained" size='small'
                     color="primary" className={classes.primaryButton}>Lagre</LoadingButton>      
                </div>

                <div className={classes.contactsInfoButtons}>
                    <Button onClick={createNewAdmin}
                    style={{minWidth: '70px'}} variant="contained" size='small' 
                    color="primary" className={classes.primaryButton}>Ny</Button>      
                </div>
                
                <div className={classes.contactsInfoButtons}>
                    <LoadingButton loading={isLoading('deleteAdmin')}  onClick={confirmDeleteAdmin}
                    style={{minWidth: '70px'}} variant="contained" size='small' 
                    color="primary" className={classes.primaryButton}>Slett</LoadingButton>      
                </div>

                <div className={classes.contactsInfoButtons}>
                    <LoadingButton loading={isLoading('kickAdmin')}  onClick={kickAdmin}
                    style={{minWidth: '70px'}} variant="contained" size='small' 
                    color="primary" className={classes.primaryButton}>Kick</LoadingButton>      
                </div>
            </div>

        </div>

        </AccordionDetails>
        </Accordion>

        <Snackbar
                open={showSnackbar}
                autoHideDuration={3000}
                onClose={_=>setShowSnackbar(false)}
                message={snackbarText}
            />

        </div>
    )
};

export default UserManagement;